import {ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot} from '@angular/router';

/**
 * @description This guards prevents employees from navigating away from the SSO 1095 viewer.
 * @export
 * @function
 * @name EmployeeGuard
 * @param {ActivatedRouteSnapshot} _ The activated route snapshot.
 * @param {RouterStateSnapshot} __ The router state snapshot.
 * @returns {boolean} True if the employee is allowed to navigate, otherwise false.
 * @todo Expand this guard as we implement more than just the 1095 viewer.
 */
export const EmployeeGuard: CanActivateFn = (_: ActivatedRouteSnapshot, __: RouterStateSnapshot): boolean => false;
